import { render, staticRenderFns } from "./DetailPromo.vue?vue&type=template&id=3394cc92&"
import script from "./DetailPromo.vue?vue&type=script&lang=js&"
export * from "./DetailPromo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports